import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import UserStore from '@/module/user/store';

Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [createPersistedState({ paths: ['session'] })],
    modules: {
        session: UserStore,
    },
});
